import { getField, updateField } from "vuex-map-fields";
import db from "@/firebase/firebaseInit";

const state = {
    allQuestions: [],
    allAnswers: [],
};

const actions = {
    async fetchAllQuestions({ commit }) {

        await db.collection('/question_answer/en/questions').get().then(
            (snapshot) => {
                var allQuestions = [];
                snapshot.forEach(doc => {
                    allQuestions.push(doc.data())
                });
                commit("updateField", {
                    path: "allQuestions",
                    value: allQuestions,
                })
            });
    },
    async fetchAllAnswers({ commit }) {

        await db.collection('/question_answer/en/faq').get().then(
            (snapshot) => {
                var allAnswers = [];
                snapshot.forEach(doc => {
                    allAnswers.push(doc.data())
                });
                commit("updateField", {
                    path: "allAnswers",
                    value: allAnswers,
                })
            });
    },
    async addAnswer({ commit }, payload) {

        await db.collection('/question_answer/en/faq').add({
            question: payload.question,
            answer: payload.answer,
            likes: 0,
        })
    },

    async deleteQuestion({ commit }, payload) {
        await db.collection('/question_answer/en/questions/').get().then(
            (snapshot) => {
                snapshot.forEach(async doc => {
                    if (doc.data().userId === payload) {
                        await db.collection('/question_answer/en/questions/').doc(doc.id).delete()
                    }
                });

            });
    },

};

const mutations = {
    updateField,
};

const getters = {
    getField,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
